import { render, staticRenderFns } from "./ProfileTests.vue?vue&type=template&id=12407c34"
import script from "./ProfileTests.vue?vue&type=script&lang=js"
export * from "./ProfileTests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports